const init = {
  loading: false,
  roadConditions: null,
  error: undefined,
  isSaved: false
};

export const roadConditions = (state = init, action) => {
  switch (action.type) {
    case "FETCH_ROAD_CONDITIONS_START":
      return { ...state, loading: true,isSaved:false };
    case "FETCH_ROAD_CONDITIONS_SUCCESS":
      return { ...state, loading: false, roadConditions: action.payload,isSaved:false };
    case "FETCH_ROAD_CONDITIONS_FAILURE":
      return { ...state, loading: false, error: action.payload,isSaved:false };
    case "SAVE_ROAD_CONDITIONS_START":
      return { ...state, loading: true, isSaved: false };
    case "SAVE_ROAD_CONDITIONS_SUCCESS":
      return { ...state, loading: false, isSaved: true,error:undefined };
    case "SAVE_ROAD_CONDITIONS_FAILURE":
      return { ...state, loading: false, error: action.payload,isSaved: false };
    default:
      return state;
  }
};
